export default "/images/story.png?44ed15ba48485caf3a108af9c9e28134";